export const createVueChildContainer = (el) => {
  const div = document.createElement('div');
  el.appendChild(div);
  return div;
};
